const pushIcon = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="138.687px" height="118.924px" viewBox="0 0 138.687 118.924" enable-background="new 0 0 138.687 118.924"
	 xml:space="preserve">
<g>
	<g>
		<path fill="#B3B2B3" d="M8.764,112.792v3.733H6.977v-3.733l-3.5-5.872h1.574c0.155,0,0.278,0.038,0.369,0.113
			s0.167,0.17,0.229,0.286l1.76,3.208c0.102,0.19,0.19,0.371,0.266,0.542c0.075,0.17,0.144,0.338,0.206,0.501
			c0.058-0.168,0.123-0.337,0.196-0.508c0.073-0.17,0.16-0.349,0.262-0.535l1.747-3.208c0.049-0.098,0.122-0.188,0.219-0.272
			c0.097-0.084,0.221-0.126,0.372-0.126h1.581L8.764,112.792z"/>
		<path fill="#B3B2B3" d="M14.955,109.604c0.509,0,0.971,0.082,1.385,0.246c0.414,0.164,0.767,0.396,1.06,0.697
			c0.292,0.301,0.518,0.669,0.677,1.103c0.16,0.434,0.239,0.919,0.239,1.455c0,0.54-0.08,1.027-0.239,1.461
			c-0.159,0.434-0.385,0.804-0.677,1.109c-0.292,0.305-0.646,0.54-1.06,0.704c-0.414,0.164-0.876,0.246-1.385,0.246
			s-0.972-0.082-1.388-0.246c-0.416-0.164-0.771-0.399-1.066-0.704c-0.295-0.306-0.523-0.675-0.685-1.109s-0.242-0.921-0.242-1.461
			c0-0.536,0.081-1.021,0.242-1.455c0.162-0.434,0.39-0.802,0.685-1.103c0.294-0.301,0.65-0.534,1.066-0.697
			C13.982,109.686,14.445,109.604,14.955,109.604z M14.955,115.363c0.567,0,0.987-0.19,1.259-0.571
			c0.272-0.381,0.409-0.938,0.409-1.674c0-0.735-0.136-1.295-0.409-1.681c-0.272-0.385-0.692-0.578-1.259-0.578
			c-0.576,0-1,0.193-1.275,0.581c-0.274,0.388-0.412,0.947-0.412,1.677c0,0.731,0.137,1.288,0.412,1.671
			C13.954,115.172,14.379,115.363,14.955,115.363z"/>
		<path fill="#B3B2B3" d="M21.099,109.71v4.331c0,0.417,0.097,0.738,0.289,0.966c0.193,0.229,0.481,0.342,0.867,0.342
			c0.284,0,0.549-0.063,0.797-0.189c0.248-0.126,0.482-0.3,0.704-0.521v-4.929h1.641v6.815h-1.003c-0.212,0-0.352-0.1-0.418-0.299
			l-0.113-0.545c-0.142,0.142-0.288,0.271-0.438,0.389c-0.151,0.118-0.312,0.217-0.482,0.299c-0.17,0.082-0.354,0.146-0.551,0.193
			c-0.197,0.046-0.408,0.07-0.634,0.07c-0.372,0-0.701-0.063-0.986-0.189c-0.286-0.126-0.526-0.305-0.721-0.535
			c-0.195-0.23-0.342-0.504-0.442-0.82c-0.1-0.317-0.149-0.666-0.149-1.046v-4.331H21.099z"/>
		<path fill="#B3B2B3" d="M27.151,116.526v-6.815h0.963c0.168,0,0.286,0.031,0.352,0.093s0.111,0.168,0.133,0.319l0.1,0.823
			c0.243-0.42,0.529-0.752,0.856-0.996c0.328-0.244,0.695-0.365,1.103-0.365c0.336,0,0.615,0.077,0.837,0.232l-0.212,1.229
			c-0.014,0.08-0.042,0.136-0.086,0.169c-0.044,0.033-0.104,0.05-0.18,0.05c-0.066,0-0.157-0.015-0.272-0.046
			c-0.115-0.031-0.268-0.046-0.458-0.046c-0.341,0-0.633,0.094-0.877,0.282c-0.244,0.188-0.449,0.464-0.618,0.827v4.245H27.151z"/>
		<path fill="#B3B2B3" d="M35.142,118.751v-9.041h1.003c0.106,0,0.197,0.024,0.272,0.073c0.075,0.049,0.124,0.124,0.146,0.226
			l0.133,0.631c0.274-0.314,0.59-0.569,0.947-0.764s0.774-0.292,1.252-0.292c0.372,0,0.712,0.077,1.02,0.232
			c0.308,0.155,0.574,0.38,0.797,0.674s0.396,0.657,0.518,1.089c0.122,0.432,0.183,0.926,0.183,1.484
			c0,0.509-0.069,0.981-0.206,1.415s-0.333,0.811-0.588,1.129c-0.254,0.319-0.562,0.568-0.923,0.747
			c-0.361,0.179-0.765,0.269-1.212,0.269c-0.385,0-0.712-0.059-0.98-0.176c-0.268-0.118-0.508-0.28-0.721-0.488v2.79H35.142z
			 M38.33,110.879c-0.341,0-0.632,0.072-0.874,0.216c-0.242,0.144-0.466,0.346-0.674,0.607v3.056
			c0.186,0.23,0.389,0.391,0.608,0.482s0.455,0.136,0.708,0.136c0.248,0,0.473-0.046,0.674-0.139
			c0.202-0.093,0.372-0.235,0.512-0.425s0.247-0.431,0.322-0.721c0.075-0.29,0.113-0.632,0.113-1.026
			c0-0.398-0.032-0.736-0.096-1.013c-0.064-0.277-0.156-0.502-0.276-0.674c-0.12-0.173-0.265-0.299-0.435-0.379
			C38.741,110.919,38.547,110.879,38.33,110.879z"/>
		<path fill="#B3B2B3" d="M45.564,109.604c0.509,0,0.971,0.082,1.385,0.246c0.414,0.164,0.767,0.396,1.06,0.697
			c0.292,0.301,0.518,0.669,0.677,1.103c0.16,0.434,0.239,0.919,0.239,1.455c0,0.54-0.08,1.027-0.239,1.461
			c-0.159,0.434-0.385,0.804-0.677,1.109c-0.292,0.305-0.646,0.54-1.06,0.704c-0.414,0.164-0.876,0.246-1.385,0.246
			s-0.972-0.082-1.388-0.246c-0.416-0.164-0.771-0.399-1.066-0.704c-0.295-0.306-0.523-0.675-0.685-1.109s-0.242-0.921-0.242-1.461
			c0-0.536,0.081-1.021,0.242-1.455c0.162-0.434,0.39-0.802,0.685-1.103c0.294-0.301,0.65-0.534,1.066-0.697
			C44.592,109.686,45.055,109.604,45.564,109.604z M45.564,115.363c0.567,0,0.987-0.19,1.259-0.571
			c0.272-0.381,0.409-0.938,0.409-1.674c0-0.735-0.136-1.295-0.409-1.681c-0.272-0.385-0.692-0.578-1.259-0.578
			c-0.576,0-1,0.193-1.275,0.581c-0.274,0.388-0.412,0.947-0.412,1.677c0,0.731,0.137,1.288,0.412,1.671
			C44.563,115.172,44.988,115.363,45.564,115.363z"/>
		<path fill="#B3B2B3" d="M54.252,111.039c-0.044,0.071-0.091,0.121-0.14,0.149s-0.111,0.043-0.186,0.043
			c-0.08,0-0.165-0.022-0.256-0.066c-0.091-0.044-0.196-0.094-0.315-0.149c-0.12-0.055-0.256-0.105-0.409-0.149
			c-0.152-0.044-0.333-0.066-0.541-0.066c-0.323,0-0.578,0.069-0.764,0.206s-0.279,0.316-0.279,0.538
			c0,0.146,0.047,0.269,0.143,0.369s0.222,0.187,0.379,0.262c0.157,0.076,0.335,0.143,0.535,0.203
			c0.199,0.06,0.403,0.125,0.611,0.196c0.208,0.071,0.412,0.151,0.611,0.242s0.377,0.206,0.535,0.345
			c0.157,0.14,0.284,0.307,0.379,0.502s0.143,0.429,0.143,0.704c0,0.328-0.06,0.63-0.179,0.907s-0.294,0.516-0.525,0.717
			s-0.515,0.358-0.854,0.472c-0.339,0.113-0.728,0.169-1.166,0.169c-0.234,0-0.464-0.021-0.688-0.063
			c-0.224-0.042-0.438-0.101-0.644-0.176s-0.396-0.164-0.571-0.266c-0.175-0.102-0.329-0.213-0.462-0.332l0.379-0.625
			c0.049-0.075,0.106-0.133,0.173-0.173c0.066-0.04,0.15-0.06,0.252-0.06c0.102,0,0.198,0.029,0.289,0.086
			c0.091,0.058,0.196,0.12,0.315,0.186c0.12,0.066,0.26,0.129,0.422,0.186c0.162,0.058,0.367,0.086,0.615,0.086
			c0.195,0,0.362-0.023,0.501-0.07c0.14-0.046,0.254-0.107,0.345-0.183c0.091-0.075,0.157-0.163,0.199-0.262
			s0.063-0.203,0.063-0.309c0-0.159-0.048-0.29-0.143-0.392c-0.095-0.102-0.221-0.19-0.378-0.266
			c-0.157-0.075-0.337-0.143-0.538-0.203c-0.202-0.06-0.408-0.125-0.618-0.196c-0.21-0.071-0.417-0.154-0.618-0.249
			c-0.201-0.095-0.381-0.216-0.538-0.362c-0.157-0.146-0.283-0.326-0.378-0.538c-0.095-0.213-0.143-0.47-0.143-0.771
			c0-0.279,0.055-0.545,0.166-0.797c0.11-0.252,0.273-0.473,0.488-0.661c0.214-0.188,0.482-0.338,0.804-0.452
			c0.321-0.113,0.692-0.169,1.112-0.169c0.47,0,0.897,0.078,1.282,0.233c0.385,0.155,0.706,0.358,0.963,0.611L54.252,111.039z"/>
		<path fill="#B3B2B3" d="M58.251,116.632c-0.589,0-1.042-0.167-1.361-0.501c-0.319-0.334-0.479-0.796-0.479-1.385v-3.806H55.72
			c-0.088,0-0.165-0.029-0.229-0.086c-0.064-0.058-0.096-0.144-0.096-0.259v-0.651l1.096-0.179l0.346-1.86
			c0.018-0.089,0.059-0.157,0.123-0.206c0.064-0.049,0.145-0.073,0.243-0.073h0.85v2.146h1.793v1.169h-1.793v3.693
			c0,0.212,0.053,0.378,0.16,0.498c0.106,0.12,0.248,0.179,0.425,0.179c0.102,0,0.187-0.012,0.256-0.036s0.128-0.05,0.179-0.077
			c0.051-0.026,0.097-0.052,0.136-0.076c0.04-0.024,0.08-0.037,0.12-0.037c0.049,0,0.089,0.012,0.12,0.037s0.064,0.061,0.1,0.109
			l0.492,0.797c-0.239,0.199-0.514,0.35-0.824,0.452C58.904,116.581,58.583,116.632,58.251,116.632z"/>
		<path fill="#B3B2B3" d="M66.627,109.604c0.509,0,0.971,0.082,1.385,0.246c0.414,0.164,0.767,0.396,1.06,0.697
			c0.292,0.301,0.518,0.669,0.677,1.103c0.16,0.434,0.239,0.919,0.239,1.455c0,0.54-0.08,1.027-0.239,1.461
			c-0.159,0.434-0.385,0.804-0.677,1.109c-0.292,0.305-0.646,0.54-1.06,0.704c-0.414,0.164-0.876,0.246-1.385,0.246
			s-0.972-0.082-1.388-0.246c-0.416-0.164-0.771-0.399-1.066-0.704c-0.295-0.306-0.523-0.675-0.685-1.109s-0.242-0.921-0.242-1.461
			c0-0.536,0.081-1.021,0.242-1.455c0.162-0.434,0.39-0.802,0.685-1.103c0.294-0.301,0.65-0.534,1.066-0.697
			C65.655,109.686,66.118,109.604,66.627,109.604z M66.627,115.363c0.567,0,0.987-0.19,1.259-0.571
			c0.272-0.381,0.409-0.938,0.409-1.674c0-0.735-0.136-1.295-0.409-1.681c-0.272-0.385-0.692-0.578-1.259-0.578
			c-0.576,0-1,0.193-1.275,0.581c-0.274,0.388-0.412,0.947-0.412,1.677c0,0.731,0.137,1.288,0.412,1.671
			C65.627,115.172,66.052,115.363,66.627,115.363z"/>
		<path fill="#B3B2B3" d="M71.271,116.526v-6.815h1.003c0.212,0,0.352,0.1,0.418,0.299l0.113,0.538
			c0.137-0.142,0.282-0.27,0.435-0.385s0.314-0.215,0.485-0.299c0.171-0.084,0.354-0.148,0.548-0.193
			c0.195-0.044,0.407-0.066,0.638-0.066c0.372,0,0.702,0.063,0.99,0.189c0.288,0.126,0.528,0.303,0.721,0.531
			c0.192,0.229,0.339,0.5,0.438,0.817c0.1,0.316,0.149,0.666,0.149,1.046v4.338h-1.641v-4.338c0-0.416-0.097-0.738-0.289-0.966
			c-0.193-0.228-0.481-0.342-0.867-0.342c-0.284,0-0.549,0.064-0.797,0.193s-0.483,0.303-0.704,0.525v4.929H71.271z"/>
		<path fill="#B3B2B3" d="M84.297,109.604c0.509,0,0.971,0.082,1.385,0.246c0.414,0.164,0.767,0.396,1.06,0.697
			c0.292,0.301,0.518,0.669,0.677,1.103c0.16,0.434,0.239,0.919,0.239,1.455c0,0.54-0.08,1.027-0.239,1.461
			c-0.159,0.434-0.385,0.804-0.677,1.109c-0.292,0.305-0.646,0.54-1.06,0.704c-0.414,0.164-0.876,0.246-1.385,0.246
			s-0.972-0.082-1.388-0.246c-0.416-0.164-0.771-0.399-1.066-0.704c-0.295-0.306-0.523-0.675-0.685-1.109s-0.242-0.921-0.242-1.461
			c0-0.536,0.081-1.021,0.242-1.455c0.162-0.434,0.39-0.802,0.685-1.103c0.294-0.301,0.65-0.534,1.066-0.697
			C83.325,109.686,83.788,109.604,84.297,109.604z M84.297,115.363c0.567,0,0.987-0.19,1.259-0.571
			c0.272-0.381,0.409-0.938,0.409-1.674c0-0.735-0.136-1.295-0.409-1.681c-0.272-0.385-0.692-0.578-1.259-0.578
			c-0.576,0-1,0.193-1.275,0.581c-0.274,0.388-0.412,0.947-0.412,1.677c0,0.731,0.137,1.288,0.412,1.671
			C83.296,115.172,83.721,115.363,84.297,115.363z"/>
		<path fill="#B3B2B3" d="M90.441,109.71v4.331c0,0.417,0.097,0.738,0.289,0.966c0.193,0.229,0.481,0.342,0.867,0.342
			c0.284,0,0.549-0.063,0.797-0.189c0.248-0.126,0.482-0.3,0.704-0.521v-4.929h1.641v6.815h-1.003c-0.212,0-0.352-0.1-0.418-0.299
			l-0.113-0.545c-0.142,0.142-0.288,0.271-0.438,0.389c-0.151,0.118-0.312,0.217-0.482,0.299c-0.17,0.082-0.354,0.146-0.551,0.193
			c-0.197,0.046-0.408,0.07-0.634,0.07c-0.372,0-0.701-0.063-0.986-0.189c-0.286-0.126-0.526-0.305-0.721-0.535
			c-0.195-0.23-0.342-0.504-0.442-0.82c-0.1-0.317-0.149-0.666-0.149-1.046v-4.331H90.441z"/>
		<path fill="#B3B2B3" d="M96.493,116.526v-6.815h0.963c0.168,0,0.286,0.031,0.352,0.093s0.111,0.168,0.133,0.319l0.1,0.823
			c0.243-0.42,0.529-0.752,0.856-0.996c0.328-0.244,0.695-0.365,1.103-0.365c0.336,0,0.615,0.077,0.837,0.232l-0.212,1.229
			c-0.014,0.08-0.042,0.136-0.086,0.169c-0.044,0.033-0.104,0.05-0.18,0.05c-0.066,0-0.157-0.015-0.272-0.046
			c-0.115-0.031-0.268-0.046-0.458-0.046c-0.341,0-0.633,0.094-0.877,0.282c-0.244,0.188-0.449,0.464-0.618,0.827v4.245H96.493z"/>
		<path fill="#B3B2B3" d="M104.504,116.526v-9.871h1.641v3.893c0.27-0.288,0.576-0.517,0.917-0.688s0.74-0.256,1.196-0.256
			c0.372,0,0.712,0.077,1.02,0.229s0.574,0.375,0.797,0.667s0.396,0.653,0.518,1.083c0.122,0.43,0.183,0.923,0.183,1.481
			c0,0.509-0.069,0.981-0.206,1.415s-0.333,0.811-0.588,1.129c-0.254,0.319-0.563,0.568-0.923,0.747s-0.765,0.269-1.212,0.269
			c-0.208,0-0.398-0.021-0.571-0.063c-0.173-0.042-0.33-0.101-0.472-0.176c-0.142-0.075-0.273-0.167-0.396-0.275
			c-0.122-0.108-0.238-0.229-0.349-0.362l-0.073,0.458c-0.026,0.115-0.072,0.197-0.136,0.246c-0.064,0.049-0.151,0.073-0.262,0.073
			H104.504z M107.692,110.879c-0.341,0-0.632,0.072-0.874,0.216c-0.242,0.144-0.466,0.346-0.674,0.607v3.056
			c0.186,0.23,0.389,0.391,0.608,0.482s0.457,0.136,0.714,0.136c0.248,0,0.472-0.046,0.671-0.139
			c0.199-0.093,0.369-0.235,0.508-0.425c0.139-0.19,0.247-0.431,0.322-0.721c0.075-0.29,0.113-0.632,0.113-1.026
			c0-0.398-0.032-0.736-0.096-1.013c-0.064-0.277-0.156-0.502-0.276-0.674c-0.12-0.173-0.265-0.299-0.435-0.379
			C108.103,110.919,107.909,110.879,107.692,110.879z"/>
		<path fill="#B3B2B3" d="M114.965,109.604c0.509,0,0.971,0.082,1.385,0.246c0.414,0.164,0.767,0.396,1.06,0.697
			c0.292,0.301,0.518,0.669,0.677,1.103c0.16,0.434,0.239,0.919,0.239,1.455c0,0.54-0.08,1.027-0.239,1.461
			c-0.159,0.434-0.385,0.804-0.677,1.109c-0.292,0.305-0.646,0.54-1.06,0.704c-0.414,0.164-0.876,0.246-1.385,0.246
			s-0.972-0.082-1.388-0.246c-0.416-0.164-0.771-0.399-1.066-0.704c-0.295-0.306-0.523-0.675-0.685-1.109s-0.242-0.921-0.242-1.461
			c0-0.536,0.081-1.021,0.242-1.455c0.162-0.434,0.39-0.802,0.685-1.103c0.294-0.301,0.65-0.534,1.066-0.697
			C113.993,109.686,114.456,109.604,114.965,109.604z M114.965,115.363c0.567,0,0.987-0.19,1.259-0.571
			c0.272-0.381,0.409-0.938,0.409-1.674c0-0.735-0.136-1.295-0.409-1.681c-0.272-0.385-0.692-0.578-1.259-0.578
			c-0.576,0-1,0.193-1.275,0.581c-0.274,0.388-0.412,0.947-0.412,1.677c0,0.731,0.137,1.288,0.412,1.671
			C113.965,115.172,114.39,115.363,114.965,115.363z"/>
		<path fill="#B3B2B3" d="M124.95,116.526h-0.738c-0.155,0-0.276-0.023-0.365-0.07c-0.088-0.046-0.155-0.141-0.199-0.282
			l-0.146-0.485c-0.173,0.155-0.342,0.291-0.508,0.409c-0.166,0.117-0.338,0.216-0.515,0.295c-0.177,0.08-0.365,0.14-0.565,0.179
			c-0.199,0.04-0.42,0.06-0.664,0.06c-0.288,0-0.554-0.039-0.797-0.117c-0.243-0.078-0.453-0.194-0.627-0.35
			c-0.175-0.155-0.311-0.349-0.409-0.58c-0.097-0.231-0.146-0.5-0.146-0.807c0-0.258,0.067-0.512,0.203-0.763
			c0.135-0.251,0.36-0.478,0.674-0.68s0.733-0.37,1.255-0.503c0.522-0.133,1.171-0.2,1.946-0.2v-0.401c0-0.46-0.096-0.8-0.289-1.021
			c-0.192-0.221-0.473-0.332-0.84-0.332c-0.266,0-0.487,0.031-0.664,0.093c-0.177,0.062-0.331,0.132-0.462,0.209
			c-0.13,0.078-0.251,0.147-0.362,0.209c-0.111,0.062-0.232,0.093-0.365,0.093c-0.111,0-0.206-0.028-0.286-0.086
			c-0.08-0.058-0.144-0.128-0.193-0.213l-0.299-0.524c0.784-0.718,1.729-1.076,2.836-1.076c0.398,0,0.754,0.065,1.066,0.196
			c0.313,0.131,0.577,0.312,0.794,0.544c0.217,0.233,0.382,0.511,0.495,0.834c0.113,0.323,0.169,0.677,0.169,1.063V116.526z
			 M121.761,115.503c0.168,0,0.323-0.015,0.465-0.046c0.142-0.03,0.275-0.076,0.402-0.137c0.126-0.061,0.248-0.136,0.365-0.226
			s0.236-0.195,0.355-0.317v-1.141c-0.479,0-0.878,0.03-1.199,0.09c-0.321,0.06-0.579,0.137-0.774,0.231s-0.333,0.203-0.415,0.328
			c-0.082,0.125-0.123,0.261-0.123,0.408c0,0.29,0.085,0.498,0.255,0.622C121.264,115.44,121.486,115.503,121.761,115.503z"/>
		<path fill="#B3B2B3" d="M126.564,116.526v-6.815h0.963c0.168,0,0.286,0.031,0.352,0.093s0.111,0.168,0.133,0.319l0.1,0.823
			c0.243-0.42,0.529-0.752,0.856-0.996c0.328-0.244,0.695-0.365,1.103-0.365c0.336,0,0.615,0.077,0.837,0.232l-0.212,1.229
			c-0.014,0.08-0.042,0.136-0.086,0.169c-0.044,0.033-0.104,0.05-0.18,0.05c-0.066,0-0.157-0.015-0.272-0.046
			c-0.115-0.031-0.268-0.046-0.458-0.046c-0.341,0-0.633,0.094-0.877,0.282c-0.244,0.188-0.449,0.464-0.618,0.827v4.245H126.564z"/>
		<path fill="#B3B2B3" d="M136.787,116.526c-0.212,0-0.352-0.1-0.418-0.299l-0.133-0.658c-0.142,0.159-0.29,0.303-0.445,0.432
			c-0.155,0.128-0.322,0.239-0.501,0.332c-0.179,0.093-0.372,0.165-0.578,0.216c-0.206,0.051-0.429,0.076-0.668,0.076
			c-0.372,0-0.713-0.078-1.023-0.232s-0.577-0.38-0.8-0.674s-0.396-0.659-0.518-1.093c-0.122-0.434-0.183-0.93-0.183-1.488
			c0-0.505,0.068-0.974,0.206-1.408c0.137-0.434,0.334-0.811,0.591-1.129s0.565-0.568,0.923-0.747
			c0.359-0.18,0.762-0.269,1.209-0.269c0.381,0,0.707,0.061,0.977,0.183c0.27,0.122,0.512,0.285,0.724,0.488v-3.601h1.641v9.871
			H136.787z M134.601,115.324c0.341,0,0.631-0.071,0.87-0.213c0.239-0.142,0.465-0.343,0.678-0.604v-3.056
			c-0.186-0.226-0.389-0.385-0.608-0.478c-0.219-0.093-0.455-0.14-0.708-0.14c-0.248,0-0.473,0.046-0.674,0.14
			c-0.202,0.093-0.372,0.233-0.512,0.422c-0.14,0.188-0.247,0.427-0.322,0.717s-0.113,0.632-0.113,1.026
			c0,0.398,0.032,0.736,0.096,1.013c0.064,0.276,0.156,0.502,0.276,0.677c0.12,0.175,0.266,0.301,0.438,0.379
			C134.196,115.285,134.389,115.324,134.601,115.324z"/>
	</g>
	<g>
		<line fill="none" stroke="#B3B2B3" stroke-miterlimit="10" x1="11.591" y1="58.104" x2="11.591" y2="99.244"/>
		<path fill="#B3B2B3" d="M14.229,57.224c0,1.458-1.181,2.64-2.638,2.64s-2.639-1.182-2.639-2.64c0-1.456,1.182-2.638,2.639-2.638
			S14.229,55.768,14.229,57.224"/>
		<g opacity="0.5">
			<g>
				<defs>
					<rect id="SVGID_1_33_" x="0.202" y="42.464" width="90.737" height="19.657"/>
				</defs>
				<use xlink:href="#SVGID_1_33_"  overflow="visible" fill="#39FDD4"/>
				<clipPath id="SVGID_1_2_">
					<use xlink:href="#SVGID_1_33_"  overflow="visible"/>
				</clipPath>
				<polygon clip-path="url(#SVGID_1_2_)" fill="#39FDD4" points="49.286,42.462 46.477,42.462 0.202,42.462 0.202,62.119 
					46.477,62.119 49.286,62.119 90.939,62.119 90.939,42.462 				"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_35_" x="46.683" y="63.793" width="45.017" height="20.067"/>
				</defs>
				<clipPath id="SVGID_1_4_">
					<use xlink:href="#SVGID_1_35_"  overflow="visible"/>
				</clipPath>
				
					<rect x="46.887" y="63.998" clip-path="url(#SVGID_1_4_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" width="44.611" height="19.658"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_37_" x="0.044" y="63.793" width="45.017" height="20.067"/>
				</defs>
				<clipPath id="SVGID_1_6_">
					<use xlink:href="#SVGID_1_37_"  overflow="visible"/>
				</clipPath>
				
					<rect x="0.246" y="63.998" clip-path="url(#SVGID_1_6_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" width="44.611" height="19.658"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_39_" x="0.155" y="42.26" width="91.448" height="20.063"/>
				</defs>
				<clipPath id="SVGID_1_8_">
					<use xlink:href="#SVGID_1_39_"  overflow="visible"/>
				</clipPath>
				<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" points="2.799,42.462 0.358,42.462 
					0.358,44.902 				"/>
				
					<line clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" stroke-dasharray="12.104,12.104" x1="0.358" y1="49.827" x2="0.358" y2="57.216"/>
				<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" points="0.358,59.679 0.358,62.119 
					2.799,62.119 				"/>
				
					<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" stroke-dasharray="12.456,12.456" points="
					7.868,62.119 46.789,62.119 49.606,62.119 86.423,62.119 				"/>
				<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" points="88.959,62.119 
					91.399,62.119 91.399,59.679 				"/>
				
					<line clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" stroke-dasharray="12.104,12.104" x1="91.399" y1="54.753" x2="91.399" y2="47.366"/>
				<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" points="91.399,44.902 
					91.399,42.462 88.959,42.462 				"/>
				
					<polyline clip-path="url(#SVGID_1_8_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" stroke-dasharray="12.456,12.456" points="
					83.889,42.462 49.606,42.462 46.789,42.462 5.333,42.462 				"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_41_" x="93.266" y="42.26" width="45.02" height="20.063"/>
				</defs>
				<clipPath id="SVGID_1_10_">
					<use xlink:href="#SVGID_1_41_"  overflow="visible"/>
				</clipPath>
				
					<rect x="93.47" y="42.462" clip-path="url(#SVGID_1_10_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" width="44.61" height="19.657"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_43_" x="93.325" y="63.793" width="45.017" height="20.067"/>
				</defs>
				<clipPath id="SVGID_1_12_">
					<use xlink:href="#SVGID_1_43_"  overflow="visible"/>
				</clipPath>
				
					<rect x="93.528" y="63.998" clip-path="url(#SVGID_1_12_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" width="44.61" height="19.658"/>
			</g>
		</g>
		<g opacity="0.3">
			<g>
				<defs>
					<rect id="SVGID_1_45_" width="138.286" height="40.787"/>
				</defs>
				<clipPath id="SVGID_1_14_">
					<use xlink:href="#SVGID_1_45_"  overflow="visible"/>
				</clipPath>
				<polygon clip-path="url(#SVGID_1_14_)" fill="none" stroke="#2E368E" stroke-miterlimit="10" points="138.021,18.223 
					138.021,0.203 98.888,0.203 93.299,0.203 44.926,0.203 40.276,0.203 0.202,0.203 0.202,18.223 0.202,19.861 0.202,40.583 
					46.75,40.583 49.574,40.583 86.177,40.583 91.471,40.583 138.08,40.583 138.08,18.223 				"/>
			</g>
		</g>
	</g>
</g>
</svg>

`;

export default pushIcon;



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/PriceOptionWeb/images/pushIcon.js